(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal?.close) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-lp-video-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dmVrInit) return;
    window.__dmVrInit = true;

    var FOCUSABLE = 'button, [href], input, select, textarea, video, [tabindex]:not([tabindex="-1"])';

    // Fill the marquee with enough copies so there is never a blank gap,
    // and shift by exactly one set width for a seamless loop.
    function setupTrack(track) {
      var marquee = track.parentElement;
      var originals = Array.prototype.filter.call(track.children, function (li) {
        return !li.hasAttribute('aria-hidden') || li.hasAttribute('data-dm-vr-original');
      });
      if (!originals.length) return;
      originals.forEach(function (li) { li.setAttribute('data-dm-vr-original', ''); });

      function build() {
        Array.prototype.slice.call(track.children).forEach(function (li) {
          if (!li.hasAttribute('data-dm-vr-original')) li.remove();
        });

        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var setWidth = 0;
        originals.forEach(function (li) {
          setWidth += li.getBoundingClientRect().width + gap;
        });
        if (!setWidth) return;

        // need the visible width + one extra set to scroll into
        var copies = Math.ceil(marquee.clientWidth / setWidth) + 1;
        var frag = document.createDocumentFragment();
        for (var c = 0; c < copies; c++) {
          originals.forEach(function (li) {
            var clone = li.cloneNode(true);
            clone.removeAttribute('data-dm-vr-original');
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('button, a').forEach(function (el) {
              el.setAttribute('tabindex', '-1');
            });
            frag.appendChild(clone);
          });
        }
        track.appendChild(frag);
        track.style.setProperty('--dm-vr-shift', -setWidth + 'px');
      }

      build();

      var lastW = marquee.clientWidth;
      var timer;
      window.addEventListener('resize', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (marquee.clientWidth === lastW) return;
          lastW = marquee.clientWidth;
          build();
        }, 150);
      });
    }

    function init(section) {
      if (section.__dmVrDone) return;
      section.__dmVrDone = true;

      section.querySelectorAll('.dm-vr__track').forEach(setupTrack);

      var modal = section.querySelector('.dm-vr__modal');
      var slot = section.querySelector('[data-dm-vr-slot]');
      var templatesRoot = section.querySelector('[data-dm-vr-templates]');
      var lastTrigger = null;

      function openModal(blockId) {
        if (!modal || !slot || !templatesRoot) return;
        var tpl = templatesRoot.content
          ? templatesRoot.content.querySelector('[data-dm-vr-template="' + blockId + '"]')
          : templatesRoot.querySelector('[data-dm-vr-template="' + blockId + '"]');
        if (!tpl) return;

        slot.innerHTML = '';
        var clone = tpl.cloneNode(true);
        while (clone.firstChild) {
          slot.appendChild(clone.firstChild);
        }

        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('dm-vr-locked');

        var media = slot.querySelector('video');
        if (media) {
          media.muted = false;
          media.volume = 1;
          var p = media.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () {
              media.muted = true;
              media.play().catch(function () {});
            });
          }
        }

        var closeBtn = modal.querySelector('.dm-vr__modal-close');
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        if (!modal || !slot) return;
        var media = slot.querySelector('video');
        if (media) {
          try {
            media.pause();
            media.removeAttribute('src');
            media.load();
          } catch (e) {}
        }
        slot.innerHTML = '';
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('dm-vr-locked');
        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          lastTrigger.focus();
        }
      }

      section.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-dm-vr-open]');
        if (opener && section.contains(opener)) {
          e.preventDefault();
          lastTrigger = opener;
          openModal(opener.getAttribute('data-block-id'));
          return;
        }
        var closer = e.target.closest('[data-dm-vr-close]');
        if (closer && section.contains(closer)) {
          e.preventDefault();
          closeModal();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (modal && modal.hidden) return;
        if (e.key === 'Escape') {
          closeModal();
          return;
        }
        if (e.key === 'Tab' && modal) {
          var focusables = modal.querySelectorAll(FOCUSABLE);
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    }

    function bootstrap() {
      document.querySelectorAll('.dm-vr').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.dm-vr');
      if (s) init(s);
    });
    document.addEventListener('shopify:section:select', function (e) {
      var s = e.target.querySelector('.dm-vr');
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal?.close) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
